import { formatDollarsCompactEven } from '..';

/**
 * Given a {@link NumberRange} object, return a label for display in the UI.
 *
 * Examples:
 *
 * { max: 0, min: 0} => '$0'
 * { max: 2500, min: 2501 } => '$2.5K'  // Both numbers format to the same string, so it would
 *                                      // look redundant to format them as a range
 * { max: 100, min: 0} => '$0 - $100'   // When the numbers format to different strings, show both
 *
 * @param range - {@link NumberRange}
 * @returns a formatted string
 */
export const getDollarRangeCompactLabel = (range: NumberRange): string => {
    const maxFormatted = formatDollarsCompactEven(range.max);
    const minFormatted = formatDollarsCompactEven(range.min);
    const rangeLabel = `${minFormatted} to ${maxFormatted}`;

    const nonZeroLabel =
        maxFormatted === minFormatted ? maxFormatted : rangeLabel;

    const label = range.max === 0 && range.min === 0 ? '$0' : nonZeroLabel;

    return label;
};
